var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EpbVirtualScrollerList',{ref:"listRef",on:{"resize":function($event){return _vm.$emit('resize', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }